import _ from 'lodash';
import Stash from './stash';
import { Api } from './utilities';

const defaults = {
  params: {},
};

export default class {
  constructor(options = defaults) {
    this.reset();
    this.setOptions(options);
  }

  setOptions(options = defaults) {
    this.options = { ...defaults, ...options };

    return this;
  }

  addOptions(options = {}) {
    this.options = { ...this.options, ...options };

    return this;
  }

  set query(query) {
    this.previousQuery = this.theQuery;
    this.theQuery = query;
  }

  get query() {
    return this.theQuery.trim();
  }

  reset(query = '') {
    this.searching = false;
    this.query = query;

    return this;
  }

  flushResults() {
    Stash.setProducts();

    return this;
  }

  search(query = null) {
    if (_.isString(query) && this.query !== query) {
      this.reset(query);
    }

    if (this.searching) {
      return this;
    }

    this.searching = true;

    const params = _.merge(
      {
        fragment: this.query,
      },
      this.options.params || {}
    );

    Api.get('products', { channel: 'foreground', params }).then(response => {
      let results = _.get(response.data, 'data', []);

      Stash.setProducts(results);

      this.searching = false;
    });

    return this;
  }
}



// WEBPACK FOOTER //
// ./src/product_finder.js